import React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';

const UserLogoutConfirmationModal = ({ isOpen, onCloseClick, onLogoutClick, username = '' }) => {
  return (
    <Modal isOpen={isOpen} size="md" centered>
      <ModalBody>
        <div className="d-flex flex-column justify-content-between align-items-center pt-4">
          <Icon.Power size={60} className="text-danger" />
          <div className="fs-4 pt-2">Are you sure?</div>
          <div className="fs-6 pt-2 text-center">
            {`Are you sure you want to log out this ${username} user? They will be signed out immediately.`}
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <Button onClick={onCloseClick} className="px-5 bg-transparent text-primary">
          Cancel
        </Button>
        <Button onClick={onLogoutClick} className="px-5 bg-danger border-danger">
          Logout
        </Button>
      </ModalFooter>
    </Modal>
  );
};

UserLogoutConfirmationModal.propTypes = {
  isOpen: PropTypes.bool,
  onCloseClick: PropTypes.func,
  onLogoutClick: PropTypes.func,
  username: PropTypes.string
};

export default UserLogoutConfirmationModal;
